
export const PROFILE_MODULE_CLASS_NAME = 'esk-2bap-profiles';

export const getProfilesModuleClassName = (className) => `${PROFILE_MODULE_CLASS_NAME}-${className}`;
